import React from "react";
import { useSite } from "../../components/public/PublicLayout";
import { Section, Eyebrow } from "../../components/public/Section";
import { PageHero } from "./About";
import InquiryForm from "../../components/public/InquiryForm";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

export default function Contact() {
  const { site } = useSite();
  return (
    <>
      <PageHero title="Contact" subtitle="Talk to our concierge — bespoke proposals within 24 hours." image="https://images.unsplash.com/photo-1663530761401-15eefb544889?auto=format&fit=crop&w=2000&q=80" />
      <Section>
        <div className="grid lg:grid-cols-5 gap-12 items-start">
          <div className="lg:col-span-2 space-y-6">
            <Eyebrow>Reach Us</Eyebrow>
            <h2 className="serif text-4xl leading-tight">Let's plate your <em className="text-shimmer not-italic">royal evening.</em></h2>
            <div className="space-y-4 mt-6">
              <ContactRow icon={Phone} title="Call" value={site?.phone || "+91 9328797924"} link={`tel:${site?.phone}`} />
              <ContactRow icon={MessageCircle} title="WhatsApp" value={site?.whatsapp || "+91 9328797924"} link={`https://wa.me/${(site?.whatsapp || "+919328797924").replace(/[^\d]/g, "")}`} />
              <ContactRow icon={Mail} title="Email" value={site?.email || "info@balajicaterers.com"} link={`mailto:${site?.email}`} />
              <ContactRow icon={MapPin} title="Address" value={site?.address || "Vadodara, Gujarat"} />
            </div>
            {site?.gst_number && <div className="border border-gold/30 p-4 mt-4 text-sm"><span className="label-eyebrow">GSTIN</span><br />{site.gst_number}</div>}
          </div>
          <div className="lg:col-span-3">
            <InquiryForm packages={[]} />
          </div>
        </div>
      </Section>

      {site?.google_maps_url && (
        <div className="w-full h-[420px]">
          <iframe title="map" src={site.google_maps_url.includes("embed") ? site.google_maps_url : `https://www.google.com/maps?q=${encodeURIComponent(site.address || "Vadodara")}&output=embed`} className="w-full h-full border-t border-gold/20" />
        </div>
      )}
    </>
  );
}

function ContactRow({ icon: Icon, title, value, link }) {
  const Inner = (
    <div className="flex items-start gap-4 border border-navy-900/10 p-4 hover:border-gold transition">
      <div className="w-10 h-10 rounded-full bg-navy-900 flex items-center justify-center"><Icon size={16} className="text-gold" /></div>
      <div>
        <div className="label-eyebrow">{title}</div>
        <div className="text-navy-900 font-semibold">{value}</div>
      </div>
    </div>
  );
  return link ? <a href={link} target="_blank" rel="noreferrer" className="block">{Inner}</a> : Inner;
}
